export default "__VITE_ASSET__sR_y9fwZ__"